import Checkmark from '../Icons/Checkmark.mjs';
import styled from 'styled-components';

const StyledCheckboxIcon = styled(Checkmark) `
  opacity: 0;
`;
const StyledCheckboxLabel = styled.label `
  display: inline-block;
`;
const StyledCheckbox = styled.span `
  display: flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.colors.checkboxBorderColor};
  border-radius: 0.25rem;
  cursor: pointer;
  transition-property: border-color, background-color;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};

  ${StyledCheckboxIcon} {
    transition-property: opacity;
    transition-duration: ${props => props.theme.animation.duration.quick1};
    transition-timing-function: ${props => props.theme.animation.easing.productive.standard};
  }
`;
const StyledCheckboxHiddenInput = styled.input.attrs({ type: 'checkbox' }) `
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;

  @media (pointer: fine) {
    &:not(:disabled):not(:checked):hover + ${StyledCheckbox} {
      border-color: ${props => props.theme.colors.checkboxBorderHoverColor};
    }
  }

  &:checked + ${StyledCheckbox} {
    border-color: ${props => props.theme.colors.skyBlue};
    background-color: ${props => props.theme.colors.skyBlue};

    ${StyledCheckboxIcon} {
      opacity: 1;
    }
  }

  @media (pointer: fine) {
    &:checked:not(:disabled):hover + ${StyledCheckbox} {
      border-color: ${props => props.theme.colors.skyBlueShade};
      background-color: ${props => props.theme.colors.skyBlueShade};
    }
  }

  &:disabled + ${StyledCheckbox} {
    cursor: default;
    opacity: 0.5;
  }
`;

export { StyledCheckbox, StyledCheckboxHiddenInput, StyledCheckboxIcon, StyledCheckboxLabel };
//# sourceMappingURL=Checkbox.styles.mjs.map
